import { DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { OtpModalComponent } from 'authentication/components/otp-modal/otp-modal.component';
import { LoginState } from 'authentication/enums/login-state.enum';
import { filter, take } from 'rxjs';
import { UserCredentials } from 'shared/interfaces/user-credentials.interface';
import { ModalService, ToastService } from 'shared/services';

export function otpHandler(
    response: any,
    userCredentials: UserCredentials,
    toastService: ToastService,
    modalService: ModalService,
    router: Router,
    destroyRef: DestroyRef,
) {
    if (response === LoginState.TWO_FACTOR_AUTHENTICATION_ENFORCED) {
        toastService.showToast({
            body: 'generalKeywords.otp.emailSent',
            severity: 'warning',
            duration: 20000,
            ignoreRemoval: true,
        });

        modalService
            .openModal(
                OtpModalComponent,
                {
                    type: 'center',
                    email: userCredentials.email,
                },
                {
                    closeOnEscape: false,
                    closeOnOverlayClick: false,
                },
            )
            .onClose.pipe(takeUntilDestroyed(destroyRef), take(1), filter(Boolean))
            .subscribe(() => {
                return router.navigate(['/dashboard']);
            });

        return false;
    }

    return true;
}
